import socialStatsCard from './socialStatsCard';
import socialStatsCardEmpty from './socialStatsCardEmpty';

export default {
    socialStatsCard,
    socialStatsCardEmpty,
};
